import { connect } from 'react-redux';
import { provideHooks } from 'redial';

import {
  loadProductsPage,
  openMobileRefineBy,
} from 'apps/catalogue/actions/catalogue';
import {
  loadCouponsSubNavigation,
} from 'apps/navigation/actions/navigation';

import ProductsPageRoute from 'apps/productsPages/utils/ProductsPageRoute';

import couponsBetaFeatures from '../betaFeatures';
import getCouponFopsUrlHelper from '../utils/getCouponFopsUrlHelper';
import CouponsPage from '../components/CouponsPage';

export default provideHooks({
  fetch: ({ location, params, dispatch, store }) => {
    const route = new ProductsPageRoute(location, params);
    const { betaFeatures } = store.getState().user;
    return dispatch(loadProductsPage(route, (...args) => getCouponFopsUrlHelper(
      betaFeatures.includes(couponsBetaFeatures.COUPONS20_PER_COUPON_GROUPING),
      ...args
    )));
  },
  defer: ({ location, params, dispatch }) => {
    const route = new ProductsPageRoute(location, params);
    dispatch(loadCouponsSubNavigation(null, { route }));
  },
})(connect(
  (state, ownProps) => {
    const productsPageRoute = new ProductsPageRoute(ownProps.location, ownProps.params);
    const routeString = productsPageRoute.toString();
    const { basePath } = productsPageRoute;

    return {
      basePath,
      betaFeatures: state.user.betaFeatures,
      productsPage: state.catalogue.productsPagesByRoute[routeString],
      routeString,
    };
  },
  { openMobileRefineBy }
)(CouponsPage));
